import { getTranslation } from '@easy-expense/intl-client';
import { Layout, Spacer, OpenSans } from '@easy-expense/ui-web-core';
import { deductibleCategories } from '@easy-expense/utils-shared';
import { lighten, darken } from 'polished';
import React from 'react';
import { SectionList } from 'react-native';

export const DeductionFinder: React.FC = () => {
  const categories = Object.values(deductibleCategories);
  const [categoryIndex, setCategoryIndex] = React.useState(0);
  const intervalRef = React.useRef<null | ReturnType<typeof setInterval>>(null);

  //artificial delay to "load" each category
  const CATEGORY_INTERVAL = 300;

  React.useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCategoryIndex((categoryIndex) => categoryIndex + 1);
    }, CATEGORY_INTERVAL);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  React.useEffect(() => {
    if (categoryIndex > categories.length) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }
  }, [categoryIndex, categories.length]);

  const percent = Math.min(Math.round((categoryIndex * 100) / categories.length), 100);

  return (
    <Layout.Column>
      <Layout.Column px={16} py radius>
        <Layout.Column align>
          <OpenSans.Primary weight="bold-700" size={24}>
            {getTranslation('Finding Deductions')}
          </OpenSans.Primary>

          <OpenSans.Primary size={64}>🔎</OpenSans.Primary>
          <Spacer.Vertical size="s-16" />
          <OpenSans.Primary size="s-16" center>
            {getTranslation('Finding your custom deduction categories...')}
          </OpenSans.Primary>
          <Spacer.Vertical size="s-16" />
          <Layout.Column
            style={{ height: 50, width: '100%' }}
            bg="brandPrimaryLight"
            radius={50}
            justify
          >
            <Layout.Column
              style={{
                height: '100%',
                width: `${percent}%`,
                minWidth: 50,
                position: 'absolute',
              }}
              bg="brandPrimary"
              radius={50}
            ></Layout.Column>
            <OpenSans.Inverse
              px={16}
              style={{ zIndex: 100 }}
              weight="bold-700"
            >{`${percent}%`}</OpenSans.Inverse>
          </Layout.Column>
        </Layout.Column>
      </Layout.Column>
      <Spacer.Vertical />
      <Layout.Row px={16} py>
        <OpenSans.Primary grow numberOfLines={1} size="s-16" weight="bold-700">
          {getTranslation('Total Categories Found')}
        </OpenSans.Primary>
        <OpenSans.Primary weight="bold-700" size="s-16">
          {Math.round(categoryIndex > categories.length ? categories.length : categoryIndex)}
        </OpenSans.Primary>
      </Layout.Row>
      <SectionList
        sections={[{ title: 'Categories', data: categories ?? [] }]}
        renderItem={({ item, index }) => {
          if (index < categories.length - categoryIndex) {
            return null;
          }
          return (
            <Layout.Column center>
              <Spacer.Vertical size={16} />

              <Layout.Column
                px
                py={4}
                radius={32}
                style={{ backgroundColor: lighten(0.33, item.color) }}
              >
                <OpenSans.Primary
                  size="s-16"
                  weight="bold-700"
                  style={{ color: darken(0.25, item.color) }}
                  center
                  numberOfLines={1}
                >
                  {`${item.emoji} ${item.value}`}
                </OpenSans.Primary>
              </Layout.Column>
            </Layout.Column>
          );
        }}
        ListFooterComponent={<Spacer.Vertical size={16} />}
      />
    </Layout.Column>
  );
};
